import {inboxSidebarFilters} from '../../inbox/inboxSidebarFilters'
import {$lang} from '@/views/settings/team/lang'

export const HOTKEY_INBOX_REPLY = 'HOTKEY_INBOX_REPLY'
export const HOTKEY_INBOX_ADD_NOTE = 'HOTKEY_INBOX_ADD_NOTE'
export const HOTKEY_INBOX_ASSIGN = 'HOTKEY_INBOX_ASSIGN'
export const HOTKEY_INBOX_LOCATION = 'HOTKEY_INBOX_LOCATION'
export const HOTKEY_INBOX_SUBSIDIARY = 'HOTKEY_INBOX_SUBSIDIARY'

export const HOTKEY_INBOX_PRIORITY = 'HOTKEY_INBOX_PRIORITY'
export const HOTKEY_INBOX_PRIORITY_URGENT = 'HOTKEY_INBOX_PRIORITY_URGENT'
export const HOTKEY_INBOX_PRIORITY_HIGH = 'HOTKEY_INBOX_PRIORITY_HIGH'
export const HOTKEY_INBOX_PRIORITY_NORMAL = 'HOTKEY_INBOX_PRIORITY_NORMAL'
export const HOTKEY_INBOX_PRIORITY_LOW = 'HOTKEY_INBOX_PRIORITY_LOW'

export const HOTKEY_INBOX_TAGS = 'HOTKEY_INBOX_TAGS'
export const HOTKEY_INBOX_EMAILS = 'HOTKEY_INBOX_EMAILS'
export const HOTKEY_INBOX_NEXT = 'HOTKEY_INBOX_NEXT'
export const HOTKEY_INBOX_PREVIOUS = 'HOTKEY_INBOX_PREVIOUS'

export const HOTKEY_INBOX_STATUS = 'HOTKEY_INBOX_STATUS'
export const HOTKEY_INBOX_STATUS_APPROVE = 'HOTKEY_INBOX_STATUS_APPROVE'
export const HOTKEY_INBOX_STATUS_ARCHIVE = 'HOTKEY_INBOX_STATUS_ARCHIVE'
export const HOTKEY_INBOX_STATUS_DECLINE = 'HOTKEY_INBOX_STATUS_DECLINE'

export const inboxHotkeys = Object.freeze({
    reply: {
        key: HOTKEY_INBOX_REPLY,
        title: 'Reply',
        description: 'Reply message',
        hotkey: 'R'
    },
    note: {
        key: HOTKEY_INBOX_ADD_NOTE,
        title: 'Add note',
        description: 'Add message note',
        hotkey: 'N'
    },
    assign: {
        key: HOTKEY_INBOX_ASSIGN,
        title: 'Assign',
        description: 'Assign member',
        hotkey: 'A'
    },
    location: {
        key: HOTKEY_INBOX_LOCATION,
        title: $lang.location.singular,
        description: `Set ${$lang.location.singular}`,
        hotkey: 'L'
    },
    subsidiary: {
        key: HOTKEY_INBOX_SUBSIDIARY,
        title: $lang.subsidiary.singular,
        description: `Set ${$lang.subsidiary.singular}`,
        hotkey: 'B'
    },
    priority: {
        key: HOTKEY_INBOX_PRIORITY,
        title: 'Priority',
        description: 'Set priority',
        hotkey: 'P',
        children: {
            urgent: {
                key: HOTKEY_INBOX_PRIORITY_URGENT,
                uuid: 'URGENT', // NOTE: keep child uuid equal to uuid in API data
                title: 'Urgent',
                description: 'Urgency urgent',
                hotkey: 'P+U'
            },
            high: {
                key: HOTKEY_INBOX_PRIORITY_HIGH,
                uuid: 'HIGH',
                title: 'High',
                description: 'Urgency high',
                hotkey: 'P+H'
            },
            normal: {
                key: HOTKEY_INBOX_PRIORITY_NORMAL,
                uuid: 'NORMAL',
                title: 'Normal',
                description: 'Urgency normal',
                hotkey: 'P+N'
            },
            low: {
                key: HOTKEY_INBOX_PRIORITY_LOW,
                uuid: 'LOW',
                title: 'Low',
                description: 'Urgency low',
                hotkey: 'P+L'
            }
        }
    },
    tags: {
        key: HOTKEY_INBOX_TAGS,
        title: 'Tags',
        description: 'Set tags',
        hotkey: 'T'
    },
    emails: {
        key: HOTKEY_INBOX_EMAILS,
        title: 'Emails',
        description: 'View emails',
        hotkey: null,
        children: {
            you: {
                key: inboxSidebarFilters.you.key,
                title: inboxSidebarFilters.you.title,
                description: 'View my emails',
                hotkey: 'G+M'
            },
            unassigned: {
                key: inboxSidebarFilters.unassigned.key,
                title: inboxSidebarFilters.unassigned.title,
                description: 'View unassigned emails',
                hotkey: 'G+U'
            },
            all: {
                key: inboxSidebarFilters.all.key,
                title: inboxSidebarFilters.all.title,
                description: 'View all emails',
                hotkey: 'G+A'
            },
            archived: {
                key: inboxSidebarFilters.archive.key,
                title: inboxSidebarFilters.archive.title,
                description: 'View archived emails',
                hotkey: 'G+H'
            }
        }
    },
    next: {
        key: HOTKEY_INBOX_NEXT,
        title: 'Next',
        description: 'Next conversation',
        hotkey: 'K'
    },
    previous: {
        key: HOTKEY_INBOX_PREVIOUS,
        title: 'Previous',
        description: 'Previous conversation',
        hotkey: 'J'
    },
    status: {
        key: HOTKEY_INBOX_STATUS,
        title: 'Status',
        description: 'Set status',
        hotkey: null,
        children: {
            approve: {
                key: HOTKEY_INBOX_STATUS_APPROVE,
                title: 'Approve',
                description: 'Approve conversation',
                hotkey: 'S+A'
            },
            decline: {
                key: HOTKEY_INBOX_STATUS_DECLINE,
                title: 'Decline',
                description: 'Decline conversation',
                hotkey: 'S+D'
            },
            archive: {
                key: HOTKEY_INBOX_STATUS_ARCHIVE,
                title: 'Archive',
                description: 'Archive conversation',
                hotkey: 'S+H'
            }
        }
    }
})
